module.exports = __webpack_public_path__ + "static/media/peo_basic_quote_image.b8d61f88.jpeg";